
<template>
    
        <mars-view class="legal-case-area"><mars-view v-if="caseInfo" class="legal-cases" @click.native.stop="goDetail"><mars-view class="case-title-wp"><mars-view class="ask-icon">问</mars-view><mars-rich-text class="case-title" :nodes="caseInfo.richTitle || (caseInfo.ask && caseInfo.ask.title)"></mars-rich-text></mars-view><mars-view class="case-lawyer"><mars-view v-if="caseInfo.lawyerInfo" class="lawyer-des"><mars-view class="lawyer-des-area"><mars-image :src="caseInfo.lawyerInfo.avatar" :lazy-load="true" class="lawyer-img"></mars-image><mars-view v-if="caseInfo.lawyerInfo.identityInfo" class="lawyer-icon"></mars-view></mars-view><mars-view class="lawyer-info"><mars-view class="lawyer-name-auto"><mars-text class="lawyer-name-content">{{ caseInfo.lawyerInfo.lawyerName }}</mars-text>执业{{ caseInfo.lawyerInfo.registerYears }}年
                        <mars-image v-if="caseInfo.lawyerInfo.membersIcon" class="lawyer-name-vip-icon" src="https://lvlin-base.cdn.bcebos.com/law/pages/iknowqa/lawyer-vip.png"></mars-image></mars-view><mars-view class="lawyer-name"><mars-text class="lawyer-name-margin-right">{{ caseInfo.lawyerInfo.registerLawFirm }}</mars-text>{{ caseInfo.domainStr }}
                    </mars-view></mars-view></mars-view></mars-view><mars-view class="case-content"><mars-view class="case-content-text"><mars-rich-text :nodes="caseInfo.richContent || (caseInfo.ask && caseInfo.ask.replieData && caseInfo.ask.replieData.contentText)"></mars-rich-text></mars-view><mars-view class="case-content-more">
                ...全文
            </mars-view></mars-view></mars-view></mars-view>
    
</template>

<script>
import log from '../../../static/utils/ubcLog';
import { act } from '../../../static/utils/navigate';
export default {
  components: {},
  props: {
    // 案例信息
    caseInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    clickArea: {
      type: String,
      default: ''
    }
  },
  computed: {
    // 律师信息
    lawyerInfo() {
      return this.caseInfo && this.caseInfo.lawyerInfo || {};
    },
    // 标题
    title() {
      let {
        title = ''
      } = this.caseInfo.ask || {};
      let newTitle = title.replace('&#65279;', '');
      return newTitle;
    }
  },
  data() {
    return {};
  },
  methods: {
    /**
     * 跳转到帖子页
     */
    goDetail() {
      let {
        ask
      } = this.caseInfo || {};
      let {
        qid
      } = ask || {};
      if (!qid) {
        return;
      }
      log.send && log.send({
        serverId: 17017,
        area: this.clickArea ? this.clickArea : 'xgtj_click',
        action: 'click'
      });
      act({
        target: `/question/${qid}?fr=law-regulation`,
        type: 'url'
      });
    }
  }
};
</script>

<style scoped>
.legal-case-area {
  padding: 4.83vw 0 3.74vw;
  margin: 0 4.11vw;
  background: #fff;
}
.legal-cases {
  margin-bottom: -0.03rem;
}
.legal-cases .case-title-wp {
  font-family: PingFang SC;
  font-size: 0.18rem;
  color: #1e1f24;
  line-height: 0.25rem;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
}
.legal-cases .case-title {
  font-family: PingFang SC;
  font-size: 0.18rem;
  color: #1e1f24;
  line-height: 0.25rem;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.legal-cases .case-title-wp .ask-icon {
  background: rgba(0, 85, 255, 0.08);
  border-radius: 0.97vw;
  font-family: PingFang SC;
  font-size: 0.13rem;
  color: #05f;
  line-height: 1;
  padding: 0.025rem 0;
  margin-right: 0.07rem;
  flex-shrink: 0;
  width: 0.18rem;
  text-align: center;
}
.legal-cases .case-content {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-top: 1.6vw;
  margin-bottom: -0.01rem;
  position: relative;
  min-height: 0.5rem;
}
.legal-cases .case-content .case-content-text {
  font-family: PingFang SC;
  font-size: 0.16rem;
  color: #1e1f24;
  line-height: 0.25rem;
}
.legal-cases .case-content .case-content-more {
  font-family: PingFang SC;
  font-size: 0.16rem;
  color: #50525c;
  line-height: 0.25rem;
  position: absolute;
  right: 0;
  bottom: 0;
  background: #fff;
}
.legal-cases .case-content .case-content-more::before {
  content: "";
  width: 0.6rem;
  height: 100%;
  position: absolute;
  left: -0.6rem;
  top: 0;
  background: linear-gradient(to right, rgba(255, 255, 255, 0), #ffffff);
}
.legal-cases .case-lawyer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.legal-cases .case-lawyer .lawyer-des {
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 0.1rem;
}
.legal-cases .case-lawyer .lawyer-des .lawyer-des-area {
  width: 0.4rem;
  height: 0.4rem;
  margin-right: 1.9324vw;
  position: relative;
}
.legal-cases .case-lawyer .lawyer-des .lawyer-des-area .lawyer-des-icon {
  width: 0.14rem;
  height: 0.14rem;
  background: url('https://iknow-pic.cdn.bcebos.com/4e4a20a4462309f7184e3a80600e0cf3d7cad67b?x-bce-process=image/quality,q_80') no-repeat;
  background-size: contain;
  position: absolute;
  bottom: 0;
  right: 0;
}
.lawyer-icon {
  width: 0.14rem;
  height: 0.14rem;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/exporthome/light.png') no-repeat;
  background-size: contain;
  position: absolute;
  bottom: -0.01rem;
  right: -0.01rem;
}
.legal-cases .case-lawyer .lawyer-des .lawyer-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.legal-cases .case-lawyer .lawyer-des .lawyer-img {
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 50%;
  background: #d8d8d8;
  border: 0.33px solid rgba(241, 241, 241, 0.4);
}
.legal-cases .case-lawyer .lawyer-des .lawyer-name {
  width: 100%;
  font-family: PingFang SC;
  font-size: 0.14rem;
  color: #848691;
  line-height: 1.1;
  margin-right: 1.4493vw;
  margin-bottom: 0.07rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.legal-cases .case-lawyer .lawyer-des .lawyer-name:last-child {
  margin-bottom: 0;
}
.legal-cases .case-lawyer .lawyer-des .lawyer-name .lawyer-name-margin-right {
  margin-right: 0.08rem;
  font-size: 0.14rem;
  color: #848691;
  font-weight: 400 !important;
}
.legal-cases .case-lawyer .lawyer-des .lawyer-name-auto {
  width: 100%;
  font-family: PingFang SC;
  font-size: 0.14rem;
  color: #848691;
  line-height: 1.1;
  margin-right: 1.4493vw;
  margin-bottom: 0.05rem;
}
.legal-cases .case-lawyer .lawyer-des .lawyer-name-auto .lawyer-name-vip-icon {
  width: 0.4rem;
  height: 3.5vw;
  vertical-align: sub;
  transform: translateY(-1px);
}
.legal-cases .case-lawyer .lawyer-des .lawyer-name-auto .lawyer-name-content {
  color: #1e1f24;
  font-size: 0.14rem;
  margin-right: 0.08rem;
  font-weight: bold;
}
.legal-cases .case-lawyer .lawyer-des .authentication-tags {
  width: 60.3865vw;
  overflow: auto;
  display: flex;
}
.legal-cases .case-lawyer .lawyer-des .authentication-tags .authentication {
  flex-shrink: 0;
  height: 3.8647vw;
  line-height: 3.8647vw;
  padding: 0 1.2077vw;
  margin-right: 1.4155vw;
  font-size: 2.4155vw;
  color: #3b6fff;
  background: #e7eeff;
  border-radius: 1.9324vw;
}
.legal-cases .case-lawyer .lawyer-des .fabulous {
  width: 3vw;
  height: 3vw;
  background-image: url('https://iknow-base.cdn.bcebos.com/iknow/new-question/action/thumb-fade.png');
  background-size: contain;
  background-repeat: no-repeat;
  margin-right: 0.9662vw;
}
.legal-cases .case-lawyer .lawyer-des .count {
  color: #999;
  font-size: 2.8986vw;
}
.legal-cases .ask-btn {
  font-size: 13px;
  color: #3b6fff;
  font-weight: 700;
}

</style>
